module.exports = "/_next/static/images/CustomSources@2x-18284c1178b0c10f3015d1491af36716.png";